
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 199","d":"M14.18 38.68L12 47l-8.14.18a32.06 32.06 0 01-.23-29.88l7.25 1.33L14 25.82a19.12 19.12 0 00.18 12.86z","fill":"#fbbb00"}}),_c('path',{attrs:{"data-name":"Path 200","d":"M63.44 26A32 32 0 0152 57l-9.13-.46-1.29-8.07a19.07 19.07 0 008.2-9.74H32.7V26z","fill":"#518ef8"}}),_c('path',{attrs:{"data-name":"Path 201","d":"M52 57a32 32 0 01-45-5 31.58 31.58 0 01-3.22-4.87l10.37-8.48a19 19 0 0024.5 11.13 18.59 18.59 0 002.92-1.39z","fill":"#28b446"}}),_c('path',{attrs:{"data-name":"Path 202","d":"M52.42 7.37l-10.37 8.49A19 19 0 0015.84 22 19.61 19.61 0 0014 25.82L3.58 17.29a32 32 0 0143.14-13.7 32.4 32.4 0 015.7 3.78z","fill":"#f14336"}})])
          )
        }
      }
    